// scribe caps catalog listings at 200 per request and defaults to 50, while the
// catalog screens render a whole organization at once. Requesting the ceiling
// and following Total keeps that behaviour without a pagination UI.
const CATALOG_PAGE_SIZE = 200;

type Page<T> = {
  items: T[];
  total: number;
};

export const fetchAllCatalogPages = async <T>(
  fetchPage: (offset: number, limit: number) => Promise<Page<T>>,
): Promise<Page<T>> => {
  const firstPage = await fetchPage(0, CATALOG_PAGE_SIZE);
  const items = [...firstPage.items];

  while (items.length < firstPage.total) {
    const nextPage = await fetchPage(items.length, CATALOG_PAGE_SIZE);

    if (nextPage.items.length === 0) {
      break;
    }

    items.push(...nextPage.items);
  }

  return { items, total: firstPage.total };
};
